import React from 'react';
import { Select } from '@chakra-ui/react';
import { dropDownFilterOptions } from '../../utils/layoutConfig';

function onChangeHandler({ filter, setFilters, e }) {
	const newFilter = { ...filter };
	const value = e.target.value;
	newFilter['sort'] = value;
	setFilters(newFilter);
}

const DropDownFilter = ({ filter, setFilters }) => {
	const [filterOptions, setFilterOptions] = React.useState(dropDownFilterOptions);

	function getDefault() {
		return filterOptions.filter((el) => el.isDefault)[0] ? filterOptions.filter((el) => el.isDefault)[0].value : '';
	}

	return (
		<Select
			defaultValue={getDefault()}
			focusBorderColor={'yellow.400'}
			onChange={(e) => onChangeHandler({ filter, setFilters, e })}
			mr={16}
		>
			{filterOptions &&
				filterOptions.map((filterOption, index) => (
					<option key={index} value={filterOption.value}>
						{filterOption.name}
					</option>
				))}
		</Select>
	);
};

export default DropDownFilter;
